import {
	Button,
	makeStyles,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SvgGoogleIcon from "../../../../components/SvgGoogleIcon";
import { GoogleSlidesApiConfig } from "../../../../entities/AppConfig";
import { AspectRatios } from "../../../../entities/AspectRatios";
import { BuilderAssetService } from "../../../../services/BuilderAssetService";
import GoogleSlidesHelperService from "../../../../services/GoogleSlides/GoogleSlidesHelperService";
import { ServerResponse } from "../../../../services/server/OldWebClient";
import { GoogleSlidesOAuthLandingPage } from "../../../GoogleSlidesOAuthLandingPage";

const useStyles = makeStyles((theme) => ({
	paper: {
		maxWidth: 340,
		[theme.breakpoints.down("sm")]: {
			margin: 12,
		},
	},
	formSelect: {
		minWidth: "90%",
		margin: "5px",
		marginLeft: "0px",
	},
	formControlOverride: {
		minWidth: "90%",
		margin: "5px",
	},
	modalCancelButton: {
		color: "#2196f3",
	},
	modalTitle: {
		fontSize: "22px",
		marginTop: "10px",
		marginBottom: "20px",
		marginLeft: "5px",
		fontWeight: 500,
	},
	selectFontLabel: {
		fontSize: "21px",
	},
	googleSignInButton: {
		"&:active": {
			backgroundColor: "#EEE",
		},
		"&:hover": {
			outline: "none",
			boxShadow: "0 0 3px 3px rgba(66,133,244,.3)",
		},
		fontFamily: "Roboto",
		color: "#898989",
		paddingLeft: "8px",
		paddingRight: "8px",
		height: "40px",
		textTransform: "none",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		border: "none",
		background: "#ffffff",
		fontSize: "18px",
	},
	googleSignInIcon: {
		marginRight: "12px",
	},
}));

interface Props {
	config: GoogleSlidesApiConfig;
	hasCustomImage: boolean;
	assetId: string;
	open: boolean;
	handleClose: () => void;
	imageAspectRatio: "16x9" | "4x3";
	defaultImageId: number;
	customSlideBackgroundImagePath?: string;
}

type FontColorOptions = "white" | "black";

export function ExportSlidesModal(props:Props) {
	const [fontColor, setFontColor] = useState<FontColorOptions>("white")
	const [signedCustomImageUrl, setSignedCustomImageUrl] = useState<string>();
	const [errorMessage, setErrorMessage] = useState<string>();
	const classes = useStyles();

	useEffect(() => {
		async function handleCustomImage(){
			const signedUrl = await getBackgroundImageUrl(props.assetId)
			setSignedCustomImageUrl(signedUrl);
		}

		if(props.hasCustomImage)
			handleCustomImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const getBackgroundImageUrl = async (id: string) => {
		let res = await BuilderAssetService.getPublicUrlForCustomSlideImage(id);
		if (ServerResponse.isError(res)) {
			return GoogleSlidesHelperService.getDefaultBackgroundImageUrlById("16x9", 1);
		} else {
			return res.data.customSlideBackgroundImagePath;
		}
	};

	const exportToGoogleSlides = async () => {
		const { defaultImageId, imageAspectRatio } = props;
		var backgroundImage = null;

		if (props.hasCustomImage) {
			if (signedCustomImageUrl) {
				backgroundImage = signedCustomImageUrl;
			} else if (props.customSlideBackgroundImagePath) {
				backgroundImage = props.customSlideBackgroundImagePath;
			} else {
				setErrorMessage(`Error: could not get custom image url for export.`);
			}
		} else {
			backgroundImage = GoogleSlidesHelperService.getDefaultBackgroundImageUrlById(imageAspectRatio, defaultImageId);
		}

		GoogleSlidesOAuthLandingPage.exportSlides(props.assetId, backgroundImage ?? "", fontColor, props.config);
		props.handleClose();
	};

	return (
		<Dialog
			open={props.open}
			onClose={props.handleClose}
			aria-labelledby="export-settings-modal"
			classes={{
				paper: classes.paper,
			}}
		>
			<DialogTitle>Present Slides</DialogTitle>
			<DialogContent>
				<FormControl className={classes.formControlOverride}>
					<InputLabel htmlFor="font-color-select" className={classes.selectFontLabel}>
						Select Font Color
					</InputLabel>
					<Select
						id="font-color-select"
						name="fontColor"
						value={fontColor}
						onChange={(e) => setFontColor(e.target.value as FontColorOptions)}
						className={classes.formSelect}
					>
						<MenuItem value="black">Dark</MenuItem>
						<MenuItem value="white">Light</MenuItem>
					</Select>
				</FormControl>
				{errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
			</DialogContent>
			<DialogActions>
				<Button onClick={props.handleClose} className={classes.modalCancelButton}>
					CANCEL
				</Button>
				<Button className={classes.googleSignInButton} onClick={() => exportToGoogleSlides()}>
					<SvgGoogleIcon className={classes.googleSignInIcon} />
					Sign in with Google
				</Button>
			</DialogActions>
		</Dialog>
	);
}